export enum PaymentStatus {
  POSTED = "POSTED", // money movement recorded (default)
  CANCELLED = "CANCELLED", // invalid / void entry
}

export enum PaymentSourceType {
  AMC = "AMC", // advance from client
  INVOICE = "INVOICE", // direct invoice payment
  CLIENT_ADVANCE = "CLIENT_ADVANCE",
  CLIENT_ADVANCE_REFUND = "CLIENT_ADVANCE_REFUND", // refund of an already-received client advance
  EMPLOYEE_ADVANCE = "EMPLOYEE_ADVANCE",
  EMPLOYEE_ADVANCE_REFUND = "EMPLOYEE_ADVANCE_REFUND", // refund of an already-disbursed employee advance
  PAYROLL_ITEM = "PAYROLL_ITEM", // salary payment for a single payroll item
  OTHER = "OTHER", // misc income
}

export enum PaymentDirection {
  IN = "IN",
  OUT = "OUT",
}

/** Who a money-out payment was actually paid to — distinct from `sourceType` (what it's for). */
export enum PaymentPayeeType {
  EMPLOYEE = "EMPLOYEE",
}

export const paymentStatusMap: Record<
  PaymentStatus,
  { label: string; color: string; hint: string }
> = {
  [PaymentStatus.POSTED]: {
    label: "Posted",
    color: "success",
    hint: "Payment is recorded and included in balances and reports.",
  },

  [PaymentStatus.CANCELLED]: {
    label: "Cancelled",
    color: "danger",
    hint: "Entry is void and should not be treated as an effective payment.",
  },
};

export const PaymentSourceLabelMap: Record<PaymentSourceType, string> = {
  [PaymentSourceType.AMC]: "AMC",
  [PaymentSourceType.CLIENT_ADVANCE]: "Client Advance",
  [PaymentSourceType.CLIENT_ADVANCE_REFUND]: "Client Advance Refund",
  [PaymentSourceType.EMPLOYEE_ADVANCE]: "Employee Advance",
  [PaymentSourceType.EMPLOYEE_ADVANCE_REFUND]: "Employee Advance Refund",
  [PaymentSourceType.INVOICE]: "Invoice",
  [PaymentSourceType.PAYROLL_ITEM]: "Payroll",
  [PaymentSourceType.OTHER]: "Other",
};

export const paymentDirectionMap: Record<
  PaymentDirection,
  {
    label: string;
    color: "success" | "danger" | "info";
    sign: "+" | "-";
    hint: string;
  }
> = {
  [PaymentDirection.IN]: {
    label: "Received",
    color: "success",
    sign: "+",
    hint: "Money in — e.g. customer payment toward an invoice.",
  },
  [PaymentDirection.OUT]: {
    label: "Paid",
    color: "danger",
    sign: "-",
    hint: "Money out — e.g. advance or disbursement.",
  },
};
